import React from 'react';
import Support from '../../components/Support';
import FooterWrapper from '../../styled-components/FooterWrapper';
import SupportSection from '../../styled-components/SupportSection';
import BBTVLogo from '../../styled-components/BBTVLogo';
import LanguageSelector from '../LanguageSelector';

class Footer extends React.Component {
  render() {
    return (
      <FooterWrapper>
        <BBTVLogo href="https://rhei.com" target="_blank">{this.props.bbtvCopyright}</BBTVLogo>
        <li className="left">
          <Support />
          <ul className="options">
            <li><a href={this.props.tos.url} target="_blank">{this.props.tos.label}</a></li>
            <li><a href={this.props.privacy.url} target="_blank">{this.props.privacy.label}</a></li>
            <li><a href={this.props.community.url} target="_blank">{this.props.community.label}</a></li>
          </ul>
        </li>
        <li className="language">
          <LanguageSelector
            items={this.props.language.allLanguages}
            language={this.props.language.selected}
            bottom
          />
        </li>
      </FooterWrapper>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js